import { TeliaSegment } from './segment';

export const getParentPath = (path: string) => {
    return path.split('/').slice(0, -1).join('/') || '/';
};

export const getComparisonPagePath = (segment: TeliaSegment, categoryPath: string) => {
    const basePath = segment === TeliaSegment.B2b ? '/verslui/palyginimas' : '/palyginimas';

    return basePath + categoryPath.replace(/^\/verslui/, '');
};
